import apiClient from '../plugins/axios';

/**
 * API Token Service
 * Swagger: POST /api-token (Create), DELETE /api-token/{id} (Delete)
 * List: GET /api-token (assumed for listing)
 */
class ApiTokenService {
  constructor() {
    this.resource = 'api-token';
  }

  /**
   * List all API tokens
   * @returns {Promise<{ success: boolean, data: Array }>}
   */
  async getList() {
    try {
      const response = await apiClient.get(`/${this.resource}`);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return { success: true, data: [] };
      }
      throw error;
    }
  }

  /**
   * Create API token
   * @param {{ name: string, description?: string }} data
   * @returns {Promise<{ success: boolean, data: { id, description?, token } }>}
   */
  async create(data) {
    try {
      const response = await apiClient.post(`/${this.resource}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Delete API token
   * @param {string} id
   * @returns {Promise}
   */
  async delete(id) {
    try {
      const response = await apiClient.delete(`/${this.resource}/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new ApiTokenService();
